export async function t(text, currentLanguage, language) {
  if (!text) return;

  if (currentLanguage !== language) {
    try {
      const response = await fetch(
        `https://api.mymemory.translated.net/get?q=${encodeURIComponent(
          text
        )}&rand=${Math.random()}&langpair=${currentLanguage}|${language}`
      );

      const data = await response.json();
      return data.responseData.translatedText;
    } catch (error) {
      return text;
    }
  } else {
    return text;
  }
}
